<script>
	module.exports = {
		props: ['selectedProduct']
	};
</script>
<style lang="scss">
	.article-single-main-footer {
		p {
			text-align: center;
		}
	}
</style>
<template>
	<div
		class="article-single-main-footer"
		v-if="selectedProduct.copyright || selectedProduct.acknowledgment">
		<div
			class="article-single-main-acknowledgment rte"
			v-if="selectedProduct.acknowledgment">
			<p>
				{{ selectedProduct.acknowledgment }}
			</p>
		</div>
		<span
			v-if="selectedProduct.copyright"
			v-html="selectedProduct.copyright">
		</span>
	</div>
</template>
